import { useState, useRef } from 'react';
import { searchTickers } from '../services/api';
import './StockSearch.css';

export default function StockSearch({ onSelect, onAdd }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const debounceRef = useRef(null);

  const handleSearch = (value) => {
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (value.length < 1) {
      setResults([]);
      setShowResults(false);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const data = await searchTickers(value);
        setResults(data.results || []);
        setShowResults(true);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 300);
  };

  const handleSelect = (ticker) => {
    onSelect({ ticker: ticker.ticker, name: ticker.name });
    setShowResults(false);
    setQuery('');
  };

  return (
    <div className="stock-search">
      <input
        type="text"
        placeholder="Search stocks (e.g. AAPL, TSLA)..."
        value={query}
        onChange={(e) => handleSearch(e.target.value)}
        onFocus={() => results.length > 0 && setShowResults(true)}
        onBlur={() => setTimeout(() => setShowResults(false), 200)}
      />
      {loading && <div className="search-loading">Searching...</div>}
      {showResults && results.length > 0 && (
        <div className="search-results">
          {results.map((t) => (
            <div key={t.ticker} className="search-result-item">
              <div className="result-info" onClick={() => handleSelect(t)}>
                <span className="result-ticker">{t.ticker}</span>
                <span className="result-name">{t.name}</span>
              </div>
              <button className="btn-add" onClick={() => onAdd(t.ticker, t.name)} title="Add to watchlist">+</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
